import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const Submit = (serviceAction, method, body) => {
  const url = `services/app/${serviceAction}`;

  if (method === 'POST') {
    return httpClient.post(url, body).then(result => result.data);
  } if (method === 'GET') {
    return httpClient.get(url, body).then(result => result.data);
  }
};

const AppInfoService = (service) => {
  const url = `${apiConstants.AppServiceInfo}?serviceName=${service}`;

  return httpClient.get(url).then(result => result.data);
};


export { AppInfoService, Submit };
